import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

import {
  BG_2,
  BORDER_2,
  FG_1,
  FG_3,
  FONT_BODY,
  FONT_SIZE_SMALL,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_SEMIBOLD,
  RADIUS_MD,
  RADIUS_SM,
  SHADOW_XS,
  WHITE,
} from 'components/upb_viewer_beta/css/betaTokens';

/**
 * BetaSegmentedToggle — small two-or-more option pill switch (iOS-style segmented
 * control). Used to let the user pick between mutually-exclusive views.
 *
 * options: [{ value, label }], value: current value, onChange: (value) => void
 */
function BetaSegmentedToggle({ options, value, onChange }) {
  return (
    <ToggleButtonGroup
      type="radio"
      name="beta-segmented-toggle"
      value={value}
      onChange={onChange}
      className={css(styles.wrap)}
    >
      {options.map(opt => (
        <ToggleButton
          key={opt.value}
          id={`beta-seg-${opt.value}`}
          value={opt.value}
          variant="link"
          className={css(styles.seg, opt.value === value && styles.segActive)}
        >
          {opt.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

const styles = StyleSheet.create({
  wrap: {
    display: 'inline-flex',
    gap: 2,
    padding: 3,
    backgroundColor: BG_2,
    border: `1px solid ${BORDER_2}`,
    borderRadius: RADIUS_MD,
  },
  seg: {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: '6px 14px',
    borderRadius: RADIUS_SM,
    fontFamily: FONT_BODY,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: FONT_SIZE_SMALL,
    color: FG_3,
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    ':hover': {
      color: FG_1,
      textDecoration: 'none',
    },
    // Suppress the react-bootstrap btn/btn-link focus ring; keep our own visuals.
    ':focus': {
      outline: 'none',
      boxShadow: 'none',
      textDecoration: 'none',
    },
  },
  segActive: {
    backgroundColor: WHITE,
    color: FG_1,
    fontWeight: FONT_WEIGHT_SEMIBOLD,
    boxShadow: SHADOW_XS,
    cursor: 'default',
  },
});

BetaSegmentedToggle.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BetaSegmentedToggle;
